/* eslint-disable no-underscore-dangle */
import React from 'react'
import { Partners } from '@shared/lib/partner'
import { MailIcon, SupportIcon, TelegramIcon } from '@shared/assets/icons'
import { ContactType } from '../model/footer.types'

const MTSOplataBotTg = {
  value: '@MTS_Oplata_assist_bot',
  label: 'Поддержка в Телеграм',
  icon: <TelegramIcon />,
  href: 'https://t.me/MTS_Oplata_assist_bot',
}

const megafonTg = {
  value: '@digital_services_support_bot',
  label: 'Поддержка в Телеграм',
  icon: <TelegramIcon />,
  href: 'https://t.me/digital_services_support_bot',
}

const MTSOplataMax = {
  value: 'МТС Оплата',
  label: 'Поддержка в MAX',
  icon: <TelegramIcon />,
  href: 'https://max.ru/u/f9LHodD0cOIPl_H6HAGZa7VJVP793h4n73Jc7M-vbqImCpxjCGD3Y-P97vA',
}

const supportChat = {
  type: 'chat' as const,
  value: 'Написать в чат',
  label: 'Поддержка на сайте',
  icon: <SupportIcon />,
}

const partnershipMail = {
  value: 'cyber@mts.ru',
  label: 'По вопросам сотрудничества',
  icon: <MailIcon />,
  href: 'mailto:cyber@mts.ru',
}

export const getContactsByPartner = (partner: Partners): ContactType[] => {
  switch (partner) {
    case Partners.DEFAULT:
      return [MTSOplataBotTg, supportChat, partnershipMail]
    case Partners.MEGAFON:
      return [megafonTg]
    default:
      return [MTSOplataBotTg, supportChat]
  }
}
// [
//   {
//     value: '@MTS_Oplata_assist_bot',
//     label: 'Поддержка в Телеграм',
//     icon: <TelegramIcon />,
//     href: 'https://t.me/MTS_Oplata_assist_bot',
//   },
//   {
//     value: 'МТС Оплата',
//     label: 'Поддержка в MAX',
//     icon: <TelegramIcon />,
//     href: 'https://max.ru/u/f9LHodD0cOIPl_H6HAGZa7VJVP793h4n73Jc7M-vbqImCpxjCGD3Y-P97vA',
//   },
//   partner === Partners.DEFAULT && {
//     value: 'Написать в чат',
//     label: 'Поддержка на сайте',
//     icon: <SupportIcon />,
//     onClick: () => window?._upservice?.setState({ isOpen: true }),
//   },
//   {
//     value: 'armusta1@mts.ru',
//     label: 'По вопросам сотрудничества',
//     icon: <MailIcon />,
//     href: 'mailto:armusta1@mts.ru',
//   },
// ].filter(Boolean) as ContactType[]
